import React, { useState, useMemo, useEffect, useContext } from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import { useHistory } from "react-router-dom";
import { filter } from "lodash";
import "./ToggleHandler.css";
import { DelayLink } from "./DelayLink";
import "./../styles/Tables.css";
import DialogBox from "./DialogBox";
import "../styles/Table2.css";
import "../styles/Button.css";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import { FormControlLabel, Switch, InputLabel } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/system/Box";
import Api_Call from "../../ApiCall";
import { Api } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import info from "../../info.json";
import UserContext from "../Common/UserContext";
const ToggleHandler = ({ active, user_id, isSkillMapping }) => {
  const [isToggled, setIsToggled] = useState(active);
  // console.log("Active", isToggled);
  const handleToggle = async () => {
    setIsToggled(!isToggled);
    try {
      const api = new Api_Call();
      const data = await api.patchData(
        "UI/USER_MANAGEMENT",
        {
          user_id: `${user_id}`,
          isActive: `${!isToggled == false ? 0 : 1}`,
        },
        info.BASE_URL_ADMIN
      );
      toast.success(data.body.msg);
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <div
        style={{
          // padding: "10px 20px",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
          // gap: "20px",
          // transform: "scale(0.5)",

          // C: isToggled ? "green" : "red",
          // color: "white",
          // border: "none",
          // borderRadius: "5px",
          // cursor: "pointer",
        }}
      >
        <p>{isToggled ? "Yes" : "No"}</p>
        <FormControlLabel
          id="toggle-btn"
          className="hoverable"
          style={
            {
              // transform: "scale(0.5)",
            }
          }
          control={
            <Switch
              checked={isToggled}
              style={
                {
                  // padding: "10px 20px",
                  // backgroundColor: isToggled ? "green" : "red",
                  // color: isToggled ? "green" : "red ",
                  // color: "white",
                  // border: "none",
                  // borderRadius: "5px",
                  // cursor: "pointer",
                }
              }
              className={`toggle-button ${isToggled ? "on" : "off"}`}
              onClick={handleToggle}
              label={isToggled ? "Active" : "Inactive"}
              disabled={isSkillMapping}
            >
              {isToggled ? "ON" : "OFF"}
            </Switch>
          }
        ></FormControlLabel>
      </div>
    </>
  );
};

export const BasicTable = (props) => {
  const [searchText, setSearchText] = useState("");
  const [activeUserIdForSkillMapping, setactiveUserIdForSkillMapping] =
    useState("");
  // console.log(props.columns);

  const [rowsToDisplay, setRowsToDisplay] = useState([]);

  const history = useHistory();

  var dynamicData = "";
  var dynamicColumn = "";
  var buttonDisplay = "";

  dynamicColumn = props.columns;
  dynamicData = props.tableData;

  const data = props.tableData;
  const columns = props.columns;

  // console.log(props.columns)
  // console.log(props.tableData);
  // const tableInstance = useTable({
  //   columns,
  //   data,

  // });

  // const {
  //   getTableProps,
  //   getTableBodyProps,
  //   headerGroups,
  //   rows,
  //   prepareRow
  // } = tableInstance;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    state: { pageIndex, pageSize: currentPageSize },
  } = useTable(
    {
      columns: props.columns,
      data: props.tableData,

      initialState: { pageIndex: 0, pageSize: 10 },
      // Start at first page
    },
    useSortBy,
    usePagination // Add pagination plugin
  );
  const [pageCount, setPageCount] = useState(0);

  // console.log(rows)

  // const filteredRows = rows.filter(row => {
  //   const rowString = JSON.stringify(row.values).toLowerCase();
  //   console.log(rowString.includes(searchText));
  //   return rowString.includes(searchText);
  // });

  const filteredRows = rows.filter((row) => {
    const rowString = JSON.stringify(row.values).toLowerCase();
    if (searchText === null) {
      return false; // Skip this row if searchText is null
    }
    return rowString.includes(searchText.toLowerCase());
  });
  // console.log(filteredRows);
  // console.log(page)

  const startTask = (e) => {
    sessionStorage.setItem("ActiveTaskID", e.target.dataset.id);
    var redirectPath = "/ClinicalAudit";
    history.push(redirectPath);
  };
  // console.log(searchText);
  // console.log(filteredRows);
  //  const rowsForTable=filteredRows.length>0 && searchText!=''?filteredRows:page;
  // const rowsForTable =
  //   searchText != "" ? (filteredRows.length > 0 ? filteredRows : []) : page;

  const startRow = pageIndex * currentPageSize;
  const endRow = startRow + currentPageSize;
  const rowsForTable = filteredRows.slice(startRow, endRow);

  //  console.log(rowsForTable)
  // useEffect(()=>{
  //   console.log("inside useeffect");
  //   if(filteredRows!=null)
  //   {
  //     setRowsToDisplay(filteredRows)
  //   }
  //   else{
  //     setRowsToDisplay(page)
  //   }
  // },[memoizedFilteredRows])

  // var showAddBtn = "";
  // if (props.AddButtonText == "" || props.AddButtonText == null) {
  //   showAddBtn = "btn--hidden";
  // } else {
  //   showAddBtn = "btn--primary";
  // }
  // var dataForProcess;
  // var setterMethod;
  // if (props.ButtonID == "BtnCPT") {
  //   dataForProcess = props.cptData;
  //   setterMethod = props.setCPTData;
  // } else if (props.ButtonID == "BtnDX") {
  //   dataForProcess = props.dxData;
  //   setterMethod = props.setDXData;
  // } else if (props.ButtonID == "BtnProvider") {
  //   dataForProcess = props.providerData;
  //   setterMethod = props.setProviderData;
  // }
  useEffect(() => {
    gotoPage(0);
  }, [searchText]);

  const editSkillHandler = async (userID) => {
    props.setIsEditPressedForSkillMapping(true);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `UI/SKILL-MAPPING?user_id=${userID}`,
        info.BASE_URL_ADMIN
      );
      console.log(data.body);
      props.setSkillsArrayForUser([...data.body]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setPageCount(Math.ceil(filteredRows.length / currentPageSize));
  }, [filteredRows, currentPageSize]);
  if (props.basic == "true") {
    if (props.loading) {
      return (
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      );
    }
    <ToastContainer />;
    return (
      <div className="tblDiv">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {" "}
          <input
            type="text"
            value={searchText}
            style={{ margin: "10px 0", width: "150px", height: "40px" }}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search..."
          />
          {/* <button className="add-user-button" onClick={props.addHandler}>
            Add User
          </button> */}
          {!props.isSkillMapping && (
            <button
              class="btn btn--primary btn--medium"
              onClick={props.addHandler}
            >
              Add User
            </button>
          )}
        </div>
        <table
          className="tblDisplay"
          {...getTableProps()}
          // className="custom-table"
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => {
                  // console.log(column);
                  return (
                    <>
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        style={{
                          width: column.width,
                          height: column.height,
                          position: "relative",
                          // display: "flex",
                          textAlign: "center",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          alignItems: "center",
                        }}
                      >
                        {/* {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''} */}
                        {column.Header == "Action" ? (
                          ""
                        ) : (
                          <>
                            <span style={{ marginRight: "20px" }}>
                              {column.render("Header")}
                            </span>
                            <span
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                position: "absolute",
                                top: "50%",
                                right: "0%",
                                transform: "translate(-50%,-50%)",
                              }}
                            >
                              <button
                                className="arrow-button up"
                                onClick={() => column.toggleSortBy()}
                              >
                                {/* ↑ */}
                                <ArrowDropUpIcon style={{ color: "white" }} />
                              </button>
                              <button
                                className="arrow-button down"
                                onClick={() => column.toggleSortBy(false)}
                              >
                                {/* ↓ */}
                                <ArrowDropDownIcon style={{ color: "white" }} />
                              </button>
                            </span>
                          </>
                        )}
                      </th>
                    </>
                  );
                })}
              </tr>
            ))}
          </thead>
          {rowsForTable.length == 0 ? (
            <tr>
              <td
                colSpan="100%"
                style={{ textAlign: "center", padding: "10px" }}
              >
                No data found...
              </td>
            </tr>
          ) : (
            <tbody {...getTableBodyProps()}>
              {rowsForTable.map((row, i) => {
                console.log(row);
                prepareRow(row);
                const user_id = row.cells.filter(
                  (item) => item.column.Header == "User ID"
                )[0].value;
                console.log("user idd", user_id);
                return (
                  <tr
                    {...row.getRowProps({
                      style: { textAlign: "center", height: "30px" },
                    })}
                  >
                    {row.cells.map((cell, index) => {
                      return (
                        <>
                          <td
                            style={{
                              ...(`${cell.value}`.length > 20 && {
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                              }),
                            }}
                            {...cell.getCellProps()}
                          >
                            {/* {cell.render("Cell")}{" "}
                          {cell.column.Header == "Active" ? (
                            <ToggleHandler />
                          ) : (
                            ""
                          )} */}
                            {cell.column.Header === "Active" ? (
                              <ToggleHandler
                                active={cell.value}
                                user_id={user_id}
                                isSkillMapping={props.isSkillMapping}
                              />
                            ) : cell.column.Header === "Action" ? (
                              !props.isSkillMapping ? (
                                <EditIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    console.log(
                                      rows.filter((item) => item.id == row.id)
                                    );
                                    props.setDataForEdit(
                                      rows
                                        .filter((item) => item.id == row.id)[0]
                                        ["cells"].map((item2) => ({
                                          key: item2["column"].Header,
                                          value: item2.value,
                                        }))
                                    );
                                    props.setisEditPressed(true);
                                  }}
                                />
                              ) : (
                                <button
                                  className="btn btn--small btn--primary"
                                  onClick={() => {
                                    setactiveUserIdForSkillMapping(
                                      row.values.USER_ID
                                    );
                                    editSkillHandler(row.values.USER_ID);
                                    sessionStorage.setItem(
                                      "userIdInUserManagement",
                                      row.original.USER_ID
                                    );
                                  }}
                                  disabled={
                                    row.values.ACTIVE == 0 ? true : false
                                  }
                                >
                                  Edit
                                </button>
                              )
                            ) : (
                              <>{cell.render("Cell")}</>
                            )}
                          </td>
                        </>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
        <div className="pagination">
          <span>
            Page{" "}
            <strong>
              {/* {pageIndex + 1} of {Math.ceil(data.length / currentPageSize)} */}
              {/* {pageIndex + 1} of{" "}
              {Math.ceil(rowsForTable.length / currentPageSize)} */}
              {filteredRows.length == 0 ? pageIndex : pageIndex + 1} of{" "}
              {pageCount}
            </strong>{" "}
          </span>
          <button
            className="pagination-button"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            Previous
          </button>
          <button
            className="pagination-button"
            onClick={() => nextPage()}
            // disabled={!canNextPage}
            disabled={
              pageIndex >= Math.ceil(filteredRows.length / currentPageSize) - 1
            }
          >
            Next
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="tblDiv">
      {/* <DialogBox
          processData={dataForProcess}
          setterMethod={setterMethod}
          buttonStyle={showAddBtn}
          AddButtonText={props.AddButtonText}
          ButtonID={props.ButtonID}
          taskStatus={props.taskStatus}
          proc={"add"}
        ></DialogBox> */}
      <table className="tblDisplay" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => {
            if (props.tableType == "default") {
              return (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: { width: column.width },
                      })}
                    >
                      {" "}
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              );
            } else if (props.tableType == "editable") {
              return (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: { width: column.width },
                      })}
                    >
                      {" "}
                      {column.render("Header")}
                    </th>
                  ))}
                  {props.taskStatus != 3 &&
                  props.taskStatus != 7 &&
                  props.taskStatus != 8 &&
                  props.taskStatus != 9 ? (
                    <th colSpan="2"></th>
                  ) : (
                    ""
                  )}
                </tr>
              );
            } else if (props.tableType == "startBtn") {
              return (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: { width: column.width },
                      })}
                    >
                      {" "}
                      {column.render("Header")}
                    </th>
                  ))}
                  <th colSpan="4"></th>
                </tr>
              );
            }
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            if (props.tableType == "default") {
              return (
                //   <tr {...row.getRowProps({ style: { textAlign: "center" } })}>
                //     {row.cells.map(cell => {
                //       return (
                //         <td {...cell.getCellProps()}>{cell.render("Cell")}</td>

                //     //     <td>
                //     //   <button type="button" className="buttonTbl">
                //     //     <i
                //     //       className="fas fa-play-circle"
                //     //       data-id={row.values.taskID}
                //     //       onClick={startTask}
                //     //     ></i>
                //     //   </button>{" "}
                //     // </td>
                //       );
                //     })}
                //   </tr>
                <tr {...row.getRowProps({ style: { textAlign: "center" } })}>
                  {row.cells.map((cell) => {
                    if (cell.column.Header === "CASE NO") {
                      // If the column header is 'CASE NO', render a link
                      return (
                        <td {...cell.getCellProps()}>
                          {props.activeStyle.audited ? (
                            <FlagCircleIcon style={{ color: "#FB4E0B" }} />
                          ) : (
                            ""
                          )}{" "}
                          <span
                            style={{
                              color: "#FB4E0B",
                              textDecoration: "underline",
                              cursor: "pointer",
                              fontWeight: "bolder",
                            }}
                            data-id={cell.value}
                            onClick={(e) => startTask(e)}
                          >
                            {cell.render("Cell")}
                          </span>
                        </td>
                      );
                    } else {
                      // For other columns, render a regular table cell
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    }
                  })}
                </tr>
              );
            } else if (props.tableType == "editable") {
              return (
                <tr {...row.getRowProps({ style: { textAlign: "center" } })}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                  {props.taskStatus != 3 &&
                  props.taskStatus != 7 &&
                  props.taskStatus != 8 &&
                  props.taskStatus != 9 ? (
                    <td>
                      {/* <DialogBox
                          className="buttonTbl"
                          processData={dataForProcess}
                          buttonStyle={showAddBtn}
                          AddButtonText={"Update"}
                          ButtonID={props.ButtonID}
                          setterMethod={setterMethod}
                          proc={"update"}
                          rowID={row.id}
                        >
                          <i className="fas fa-pen"></i>
                        </DialogBox>  */}
                    </td>
                  ) : (
                    ""
                  )}
                  {props.taskStatus != 3 &&
                  props.taskStatus != 7 &&
                  props.taskStatus != 8 &&
                  props.taskStatus != 9 ? (
                    <td>
                      {/* <DialogBox
                          className="buttonTbl"
                          processData={dataForProcess}
                          buttonStyle={showAddBtn}
                          AddButtonText={"Remove"}
                          ButtonID={props.ButtonID}
                          setterMethod={setterMethod}
                          proc={"delete"}
                          rowID={row.id}
                        >
                          <i className="fas fa-trash"></i>
                        </DialogBox>  */}
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              );
            } else if (props.tableType == "startBtn") {
              return (
                <tr {...row.getRowProps({ style: { textAlign: "center" } })}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                  <td>
                    <button type="button" className="buttonTbl">
                      <i
                        className="fas fa-play-circle"
                        data-id={row.values.taskID}
                        onClick={startTask}
                      ></i>
                    </button>{" "}
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
      <br></br>
    </div>
  );
};
